// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2-acH","addWidgetButton":"Header_addWidgetButton__24d3k","dashboardTabs":"Header_dashboardTabs__31lYg","active":"Header_active__3EDcE"};